import React, { useEffect } from "react";
// import Header from './../components/Header';
import xls from "xlsx";
import { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { uploadTransaction } from "./../stores/services/beta-transaction.service";
import { JsonToTable } from "react-json-to-table";
// import { getFundByAmc } from "./../stores/services/funds.service";
// import { getAccountByFund } from "./../stores/services/account.service";
import { Modal } from "react-bootstrap";
import moment from "moment";
import * as fs from "fs";
import { uploadTransaction } from "../../stores/services/beta-transaction.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import { env } from "../../env";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../utils/customFunction";

let csvToJson = require("convert-csv-to-json");
const csv = require("csvtojson/v2");


let xlsxToJson = require("convert-excel-to-json");
// const xlsx = require('xlsx-to-json');

const LegacyPastFinancialPeriodUploader = () => {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

    const fileKeys = ["StartDate", "EndDate", "Description", "Period"]
    const history = useHistory();
    const amcCode = sessionStorage.getItem("amc_code") || "";
    const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");

    const [loading, setLoading] = useState(false);
    const [fileData, setfileData] = useState<any>([]);
    const [fileDataCount, setFileDataCount] = useState(0);
    const myRef1 = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState("");
    const [fileError, setFileError] = useState("");
    const [file, setFile] = useState("");
    const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
    const email = sessionStorage.getItem("email") || "";
    const [errorInFile, setErrorInFile] = useState(false)
    const [loadingFileUpload, setLoadingFileUpload] = useState(false)


    const upload = async (e: any) => {
        if (e?.target.files[0]) {
            setFileError("");
            setfileData(null);
            let file = e?.target.files[0];

            let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
            if (type === "xlsx" || type === "csv") {
                setFile(file);
                setFileName(file?.name);
                //start

                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target?.result;
                    const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data: any = xls.utils.sheet_to_json(ws, {
                        header: 2,
                        raw: false,
                        defval: "",
                        dateNF: "YYYY-MM-DD",
                    });
                    // if file is empty 
                    if (data?.length === 0) {
                        toast.error("File Should not be empty")
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }
                    // check if uploaded file doesn not contain any other key that is not present in sample file
                    const uploadedHeaders = Object.keys(data[0])?.filter((ele) => !ele?.includes("__EMPTY"))?.map((item1) => item1?.trim()?.toLowerCase());// remvoving spaces for better matching
                    // console.log("uploadedHeaders", uploadedHeaders)

                    const checkRequiredFields = (data, requiredFields) => {
                        return data.some(row => {
                            return requiredFields.some(field => {
                                const value = row[field.trim()]?.toString().trim(); // get trim valu
                                return !value; // true if valu is emoty
                            });
                        });
                    };

                    const headersMatch =
                        uploadedHeaders?.length > fileKeys?.length ?
                            uploadedHeaders?.every(header => {
                                return fileKeys.includes(header.trim()?.toLowerCase())
                            }) :
                            fileKeys?.every(header => {
                                return uploadedHeaders.includes(header.trim()?.toLowerCase())
                            })
                        ;

                    if (!headersMatch) {
                        toast.error("Uploaded file headers do not match the expected format.");
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return;
                    }


                    const hasEmptyAccountsFields = checkRequiredFields(data, fileKeys);

                    if (hasEmptyAccountsFields) {
                        setErrorInFile(true)
                    }
                    else {
                        setErrorInFile(false)
                    }

                    /* Update state */

                    //  let jsonarray:any = [];
                    if (data.length > 0) {
                        // filter those keys which has ___Empty 
                        const filteredData = data.map(obj => {
                            return Object.fromEntries(
                                Object.entries(obj).filter(([key]) => !key.startsWith('__EMPTY'))
                            );
                        });
                        setfileData(filteredData);
                        setFileDataCount(data.length);
                    }
                };
                if (rABS) reader.readAsBinaryString(file);
                else reader.readAsArrayBuffer(file);
                // end 2
            } else {
                toast.error("Please Upload Correct Format of File");
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
            }
            // removing value so that user can upload same file again
            e.target.value = ""
        }
    };

    const renderTable = () => {
        return fileData?.map((item: any, index: number) => {
            return (
                <tr key={index}>
                    {Object.entries(item).map(([key, value]: [string, any]) => {
                        let isHighlighted = false;

                        if (fileKeys?.includes(key) && value?.trim() === "") {
                            isHighlighted = true;
                        }
                        return (
                            <td key={key}
                                style={{
                                    backgroundColor: isHighlighted ? "#8b0000" : "",
                                    border: "1px solid #525f7f"
                                }}
                            >
                                {typeof value === "number"
                                    ? numberWithCommas(value.toFixed(4))
                                    : value}
                            </td>
                        )
                    })}
                </tr>
            );
        });
    }

    const handleUploadFiles = async () => {
        setLoadingFileUpload(true)
        if (errorInFile === true) {
            toast.error("First fill the required fields")
            setLoadingFileUpload(false)
            return
        }
        try {


        } catch (error) {
            console.log("error is:", error)
            toast.error("Error Uploading File")
        } finally {

        }
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <ToastContainer limit={1} />
                            <div className="card">
                                <div className="">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            Legacy Financial Period Bulk Upload
                                            <Dropdown className="float-right">
                                                <Dropdown.Toggle href={`${env.REACT_APP_SAMPLE_URL}Financial_Period.xlsx`} variant="dark" id="dropdown-basic">
                                                    Download Sample
                                                </Dropdown.Toggle>
                                            </Dropdown>
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        <Row className="mb-3">
                                            <Col md="6">
                                                <label>Choose File </label>
                                                <div
                                                    className="form-control multi-input ml-auto"
                                                    style={{
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => myRef1?.current?.click()}
                                                >
                                                    <div className="form-group mb-0">
                                                        <div className="fom-control ml-2">
                                                            {fileName === "" ? "Upload File" : fileName}
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            ref={myRef1}
                                                            style={{ display: "none" }}
                                                            multiple={false}
                                                            onChange={(e) => {
                                                                upload(e);
                                                            }}
                                                        />
                                                        {fileError ? (
                                                            <p className="error-labels error-message2">
                                                                {fileError}
                                                            </p>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                </div>
                                                {fileUploadingFlag && (
                                                    <img src="assets/loader.svg" width="50" />
                                                )}
                                            </Col>
                                        </Row>
                                        {
                                            fileData?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table
                                                        className="table mt-3 ">
                                                        <thead>
                                                            {
                                                                Object.keys(fileData?.[0])?.map((heading) => {
                                                                    return (
                                                                        <th
                                                                            style={{
                                                                                paddingLeft: "7px",
                                                                                paddingRight: "7px",
                                                                                border: "1px solid"
                                                                            }}
                                                                            className="text-nowrap"
                                                                        >
                                                                            {heading}
                                                                        </th>
                                                                    )
                                                                })}

                                                        </thead>
                                                        <tbody>{renderTable()}</tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                fileName ?
                                                    <Row className="d-flex justify-content-center my-3">
                                                        <i
                                                            className="fa fa-spinner fa-spin fa-3x"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </Row> : null
                                            )
                                        }
                                        Total Rows:{" "}
                                        <span className="text-primary mt-3">{fileDataCount} </span>
                                        <div className="mt-4">
                                            <button
                                                className="btn btn-primary"
                                                disabled={Boolean(loading) || fileData?.length < 1 || loadingFileUpload}
                                                onClick={() => handleUploadFiles()}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border login-txt spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        <span className="login-txt"> Loading...</span>
                                                    </>
                                                ) : (
                                                    <span>Upload</span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default LegacyPastFinancialPeriodUploader;
